// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DimensionUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Get width of client
 */
function getWidth() {
  const docElement = document.documentElement;
  const body = document.getElementsByTagName('body')[0];
  return window.innerWidth || docElement.clientWidth || body.clientWidth;
}

/**
 * Get height of client
 */
function getHeight() {
  const docElement = document.documentElement;
  const body = document.getElementsByTagName('body')[0];
  return window.innerHeight || docElement.clientHeight || body.clientHeight;
}

/**
 * Convert VH to Px
 * @param {Number} sourceInVh Height in VH
 */
function vh2px(sourceInVh: number) {
  return {
    value: (getHeight() * sourceInVh) / 100,
    unit: 'px'
  };
}

/**
 * Convert Px to VH
 * @param {Number} sourceInPx Height in Px
 */
function px2vh(sourceInPx: number) {
  return {
    value: (sourceInPx * 100) / getHeight(),
    unit: 'vh'
  };
}

/**
 * Convert Rem to Px
 * @param {Number} sourceInRem Value in rem
 */
function rem2px(sourceInRem: number = 1) {
  return sourceInRem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export default {
  getWidth,
  getHeight,
  vh2px,
  px2vh,
  rem2px
};



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.DimensionUtils.js